// extracted by mini-css-extract-plugin
export default {"sessionBreak":"Session_sessionBreak__apFBK"};